import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { CompatibleSignedUrlPayload } from 'Interfaces/Common';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: CompatibleSignedUrlPayload) =>
    $actions.user.getCompatibleSignedGetUrl(dispatch, payload),
  );
};
